import React, { useState } from "react";
import { FaGlobe } from "react-icons/fa";
import UseGoogleTranslate from "../UseGoogleTranslate";

const LanguageModal = ({ showModal, setShowModal }) => {
    // const [showModal, setShowModal] = useState(false);

    return (
        <>
            {/* Floating Globe Button */}
            {/* <button
                className="btn btn-primary rounded-circle position-fixed bottom-0 end-0 m-4 shadow d-flex align-items-center justify-content-center"
                style={{ width: "56px", height: "56px", zIndex: 998 }}
                onClick={() => setShowModal(true)}
                title="Change Language"
            >
                <FaGlobe size={22} />
            </button> */}

            {/* Bootstrap Modal */}
            {showModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        zIndex: 999,
                    }}
                    onClick={() => setShowModal(false)} // close when backdrop clicked
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        onClick={(e) => e.stopPropagation()} // prevent closing on modal click
                    >
                        <div className="modal-content border-0 shadow-lg">
                            {/* Header */}
                            <div className="modal-header border-0">
                                <h5 className="modal-title d-flex align-items-center gap-2">
                                    <FaGlobe className="text-primary" />
                                    Select Language
                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={() => setShowModal(false)}
                                ></button>
                            </div>

                            {/* Body */}
                            <div className="modal-body text-center">
                                <UseGoogleTranslate />
                            </div>

                            {/* Footer */}
                            <div className="modal-footer border-0">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowModal(false)}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default LanguageModal;
